'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n  @font-face {\n    font-family: "GriddleIcon";\n    src: url(', ');\n    src: url(', '?#iefix) format("embedded-opentype"),\n         url(', ') format("woff"),\n         url(', ') format("truetype"),\n         url(', '#GriddleIcon) format("svg");\n\n    font-style: normal;\n    font-weight: normal;\n  }\n'], ['\n  @font-face {\n    font-family: "GriddleIcon";\n    src: url(', ');\n    src: url(', '?#iefix) format("embedded-opentype"),\n         url(', ') format("woff"),\n         url(', ') format("truetype"),\n         url(', '#GriddleIcon) format("svg");\n\n    font-style: normal;\n    font-weight: normal;\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  table {\n    width: 100%;\n  }\n\n  .griddle {\n    font-family: ', ';\n    th {\n      text-align: left;\n      padding: 10px 16px;\n      color: ', ';\n      font-family: ', ';\n      background: ', ';\n    }\n    td {\n      padding: 19px 16px;\n    }\n    .grid-alignRight {\n      text-align: right;\n    }\n\n    .standard-row {\n      &:nth-child(even) {\n        background: #fafafa;\n      }\n      border-bottom: 1px solid ', ';\n      &:hover {\n        color: ', ';\n        cursor: pointer;\n      }\n      td {\n        &:last-child {\n          text-align: right;\n        }\n      }\n    }\n\n    .griddle-previous,\n    .griddle-page,\n    .griddle-next {\n      float: left;\n      width: 33%;\n      min-height: 1px;\n      margin-top: 5px;\n    }\n\n    .griddle-previous,\n    .griddle-next {\n      button {\n      }\n    }\n\n    .griddle-page {\n      text-align: center;\n    }\n    .griddle-next {\n      text-align: right;\n    }\n\n    .footer-container {\n      padding: 19px 16px 0 16px;\n    }\n  }\n\n  .grid-sort-default {\n    span {\n      &:after {\n        font-size: 12px;\n        vertical-align: middle;\n        margin-left: 10px;\n      }\n    }\n  }\n\n  .grid-sort-default {\n    cursor: pointer;\n    span:after {\n      ', '\n      content: \'\\e904\';\n      opacity: 0.3;\n    }\n  }\n\n  .sort-column-descending {\n    span:after {\n      ', '\n      content: \'\\e902\';\n      opacity: 1;\n    }\n  }\n\n  .sort-column-ascending {\n    span:after {\n      ', '\n      content: \'\\e903\';\n      opacity: 1;\n    }\n  }\n'], ['\n  table {\n    width: 100%;\n  }\n\n  .griddle {\n    font-family: ', ';\n    th {\n      text-align: left;\n      padding: 10px 16px;\n      color: ', ';\n      font-family: ', ';\n      background: ', ';\n    }\n    td {\n      padding: 19px 16px;\n    }\n    .grid-alignRight {\n      text-align: right;\n    }\n\n    .standard-row {\n      &:nth-child(even) {\n        background: #fafafa;\n      }\n      border-bottom: 1px solid ', ';\n      &:hover {\n        color: ', ';\n        cursor: pointer;\n      }\n      td {\n        &:last-child {\n          text-align: right;\n        }\n      }\n    }\n\n    .griddle-previous,\n    .griddle-page,\n    .griddle-next {\n      float: left;\n      width: 33%;\n      min-height: 1px;\n      margin-top: 5px;\n    }\n\n    .griddle-previous,\n    .griddle-next {\n      button {\n      }\n    }\n\n    .griddle-page {\n      text-align: center;\n    }\n    .griddle-next {\n      text-align: right;\n    }\n\n    .footer-container {\n      padding: 19px 16px 0 16px;\n    }\n  }\n\n  .grid-sort-default {\n    span {\n      &:after {\n        font-size: 12px;\n        vertical-align: middle;\n        margin-left: 10px;\n      }\n    }\n  }\n\n  .grid-sort-default {\n    cursor: pointer;\n    span:after {\n      ', '\n      content: \'\\\\e904\';\n      opacity: 0.3;\n    }\n  }\n\n  .sort-column-descending {\n    span:after {\n      ', '\n      content: \'\\\\e902\';\n      opacity: 1;\n    }\n  }\n\n  .sort-column-ascending {\n    span:after {\n      ', '\n      content: \'\\\\e903\';\n      opacity: 1;\n    }\n  }\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _griddleReact = require('griddle-react');

var _griddleReact2 = _interopRequireDefault(_griddleReact);

var _NitroDataGridPagination = require('./NitroDataGridPagination');

var _NitroDataGridPagination2 = _interopRequireDefault(_NitroDataGridPagination);

var _nitroLoading = require('../nitro-loading');

var _nitroLoading2 = _interopRequireDefault(_nitroLoading);

var _nitroContentNotAvailable = require('../nitro-content-not-available');

var _nitroContentNotAvailable2 = _interopRequireDefault(_nitroContentNotAvailable);

var _Font = require('./Font');

var _Font2 = _interopRequireDefault(_Font);

var _GriddleIcons = require('../../assets/icons/GriddleIcons.eot');

var _GriddleIcons2 = _interopRequireDefault(_GriddleIcons);

var _GriddleIcons3 = require('../../assets/icons/GriddleIcons.woff');

var _GriddleIcons4 = _interopRequireDefault(_GriddleIcons3);

var _GriddleIcons5 = require('../../assets/icons/GriddleIcons.ttf');

var _GriddleIcons6 = _interopRequireDefault(_GriddleIcons5);

var _GriddleIcons7 = require('../../assets/icons/GriddleIcons.svg');

var _GriddleIcons8 = _interopRequireDefault(_GriddleIcons7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

(0, _styledComponents.injectGlobal)(_templateObject, _GriddleIcons2.default, _GriddleIcons2.default, _GriddleIcons4.default, _GriddleIcons6.default, _GriddleIcons8.default);

var TableContainer = _styledComponents2.default.section(_templateObject2, function (props) {
  return props.theme.font.default;
}, function (props) {
  return props.theme.color.white;
}, function (props) {
  return props.theme.font.bold;
}, function (props) {
  return props.theme.color.secondary;
}, function (props) {
  return props.theme.color.border;
}, function (props) {
  return props.theme.color.secondary;
}, _Font2.default, _Font2.default, _Font2.default);

TableContainer.displayName = 'TableContainer';

var NitroDataGrid = function (_Component) {
  _inherits(NitroDataGrid, _Component);

  function NitroDataGrid(props, context) {
    _classCallCheck(this, NitroDataGrid);

    // Initialize to the first page of results.
    var _this = _possibleConstructorReturn(this, (NitroDataGrid.__proto__ || Object.getPrototypeOf(NitroDataGrid)).call(this, props, context));

    _this.state = {
      results: [],
      currentPage: 0,
      maxPages: 0,
      externalResultsPerPage: 10,
      externalSortColumn: null,
      externalSortAscending: true,
      sortQuery: ''
    };
    _this.setPage = _this.setPage.bind(_this);
    _this.changeSort = _this.changeSort.bind(_this);
    _this.setPageSize = _this.setPageSize.bind(_this);
    return _this;
  }

  _createClass(NitroDataGrid, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps === this.props) {
        return;
      }
      this.setState({
        maxPages: Math.ceil(nextProps.totalCount / nextProps.rowPerPage),
        currentPage: nextProps.currentPage
      });
    }
  }, {
    key: 'setPage',
    value: function setPage(index) {
      // This should interact with the data source to get the page at the given index
      this.setState({
        results: this.props.fetchExternalData(index, this.state.sortQuery),
        currentPage: index
      });
    }

    // On sort of columns call the external api with + for ascending and - for descending

  }, {
    key: 'changeSort',
    value: function changeSort(sort, sortAscending) {
      // this should change the sort for the given column
      var sortQuery = '';

      if (sortAscending) {
        sortQuery = '+' + sort;
      } else {
        sortQuery = '-' + sort;
      }
      this.setState({
        results: this.props.fetchExternalData(0, sortQuery),
        externalSortColumn: sort,
        externalSortAscending: sortAscending,
        sortQuery: sortQuery
      });
    }
  }, {
    key: 'setPageSize',
    value: function setPageSize(size) {}
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          className = _props.className,
          results = _props.results,
          rowPerPage = _props.rowPerPage,
          columnMetaData = _props.columnMetaData,
          dataFetching = _props.dataFetching,
          onRowClick = _props.onRowClick,
          uniqueKey = _props.uniqueKey,
          totalCount = _props.totalCount;
      var _state = this.state,
          maxPages = _state.maxPages,
          currentPage = _state.currentPage,
          externalSortColumn = _state.externalSortColumn,
          externalSortAscending = _state.externalSortAscending,
          setPage = _state.setPage;


      var Loading = function Loading() {
        return _react2.default.createElement(_nitroLoading2.default, { position: 'center', wrapper: true });
      };
      var Pager = function Pager(props) {
        return _react2.default.createElement(_NitroDataGridPagination2.default, _extends({}, _this2.props, props, { maxPage: maxPages }));
      };
      return _react2.default.createElement(
        TableContainer,
        { className: className },
        _react2.default.createElement(_griddleReact2.default, {
          useExternal: true,
          key: uniqueKey,
          externalSetPage: this.setPage,
          externalChangeSort: this.changeSort,
          externalSetFilter: false,
          externalMaxPage: maxPages,
          externalCurrentPage: currentPage,
          results: results,
          resultsPerPage: rowPerPage,
          externalSetPageSize: this.setPageSize,
          externalSortColumn: externalSortColumn,
          externalSortAscending: externalSortAscending,
          showFilter: false,
          showSettings: false,
          columnMetadata: columnMetaData,
          useGriddleStyles: false,
          onRowClick: onRowClick,
          columns: columnMetaData.map(function (col) {
            return col.columnName;
          }),
          externalIsLoading: dataFetching,
          externalLoadingComponent: Loading,
          useCustomPagerComponent: true,
          showPager: !dataFetching,
          customPagerComponent: function customPagerComponent(props) {
            return Pager(props);
          },
          customNoDataComponent: _nitroContentNotAvailable2.default,
          sortAscendingComponent: ' ',
          sortDescendingComponent: ' ',
          sortAscendingClassName: 'sort-column-ascending',
          sortDescendingClassName: 'sort-column-descending'
        })
      );
    }
  }]);

  return NitroDataGrid;
}(_react.Component);

NitroDataGrid.propTypes = {
  results: _propTypes2.default.array,
  totalCount: _propTypes2.default.number,
  rowPerPage: _propTypes2.default.number,
  fetchExternalData: _propTypes2.default.func,
  onRowClick: _propTypes2.default.func,
  columnMetaData: _propTypes2.default.array,
  currentPage: _propTypes2.default.number,
  dataFetching: _propTypes2.default.bool,
  sortColumnAscendingCls: _propTypes2.default.string,
  sortColumnDescendingCls: _propTypes2.default.string,
  className: _propTypes2.default.string,
  uniqueKey: _propTypes2.default.string // Column metadata never changes dynamically - workaround in 0. version of griddle is to refresh the griddle with key
  // https://github.com/GriddleGriddle/Griddle/issues/352 - Sriram
};

NitroDataGrid.defaultProps = {
  columnMetaData: []
};

exports.default = NitroDataGrid;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-data-grid/NitroDataGrid.js
// module id = 2898
// module chunks = 4